module.exports = __webpack_public_path__ + "static/media/toycharm.8fb9d35d.png";